import Vue from "vue";
import axios from "axios";
import "../../filters";

export default {
  name: "agreementDetails",
  props: ["dataObj"],
  components: {
    reportsComp: require("../../common/reports/reports.vue").default,
  },
  data: function () {
    return {
      account: "",
      agreemNo: 0,
      agreement: null,
      installments: [],
      bCancelAgreemShowDialog: false,
      cancelationReason: "",
      installmentsDtl: {},
      settings: {},
      showReportsDialog: false,
      reports: [],
    };
  },
  computed: {},
  watch: {},
  created() {
    this.account = this.$route.params.account;
    this.agreemNo = this.$route.params.no;
    this.getSettings();
    this.getAgreement();
    this.getReports();
  },
  methods: {
    getSettings() {
      axios
        .get("/CustomerAgreement/GetSettings")
        .then((response) => {
          this.settings = response.data;
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getAgreement() {
      const parameters = {
        account: this.account,
        agreemNo: this.agreemNo,
      };

      axios
        .post("/CustomerAgreement/GetCustomerAgreement", parameters)
        .then((response) => {
          this.agreement = response.data;
          this.getCustomerAgreementInstallmentsAndBalance();
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    getCustomerAgreementInstallmentsAndBalance() {
      axios
        .post(
          "/CustomerAgreement/GetCustomerAgreementInstallmentsAndBalance?account=" +
            this.account +
            "&agreemNo=" +
            this.agreemNo +
            "&pageIndex=1&pageSize=1000"
        )
        .then((response) => {
          response["completionDate"] = response["lastInstallmentDate"];

          console.log(response);
          this.installments = response.data.items;

          if (this.agreement.penaltyType != 0) {
            for (var i = 0; i < this.installments.length; i++) {
              this.installments[i].penalty =
                this.agreement.penaltyType == 1
                  ? Number(
                      (
                        (this.installments[i].amount *
                          this.agreement.penaltyValue) /
                        100
                      ).toFixed(2)
                    )
                  : Number(this.agreement.penaltyValue.toFixed(2));

              this.installments[i].total =
                this.installments[i].penalty + this.installments[i].amount;
            }
          }

          this.installmentsDtl.totalAmount = this.installments
            .reduce((a, b) => {
              return a + b.amount;
            }, 0)
            .toFixed(2);
          this.installmentsDtl.totalCount = this.installments.length;
          this.installmentsDtl.totalIssudAmount = this.installments
            .filter((a) => a.charged)
            .reduce((a, b) => {
              return a + b.amount;
            }, 0)
            .toFixed(2);
          this.installmentsDtl.totalIssudCount = this.installments.filter(
            (a) => a.charged
          ).length;
          this.installmentsDtl.totalRestAmount =
            this.installmentsDtl.totalAmount -
            this.installmentsDtl.totalIssudAmount;
          this.installmentsDtl.totalRestCount =
            this.installmentsDtl.totalCount -
            this.installmentsDtl.totalIssudCount;

          //this.bShowInstallments = true;
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    cancelAgreementConfirm() {
      this.bCancelAgreemShowDialog = true;
    },
    cancelCustomerAgreement() {
      if (this.cancelationReason.trim() === "") {
        this.$alertMsg(this.$t("customerAgreements.invalidCancelationReason"));
        return;
      }

      const parameters = {
        account: this.account,
        agreemNo: this.agreemNo,
        reason: this.cancelationReason,
      };

      axios
        .post("/CustomerAgreement/CancelCustomerAgreement", parameters)
        .then((response) => {
          this.$alertMsg(this.$t("messages.CancelAgreementsSuccess"), 2);
          this.$router.go(-1);
        })
        .catch((error) => {
          this.$alertMsg(error.response.data);
        });
    },
    undoCancelAgreement() {
      this.bCancelAgreemShowDialog = false;
      this.cancelationReason = "";
    },
    getReports() {
      axios
        .get("/CustomerAgreement/GetReports")
        .then((response) => {
          if (response.status == 200) {
            this.reports = response.data;
          }
        })
        .catch((err) => {
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text);
        });
    },
    printReport(reportId) {
      axios
        .post(
          "/CustomerAgreement/CreateReport?reportId=" +
            reportId +
            "&account=" +
            this.account +
            "&agreemNo=" +
            this.agreemNo
        )
        .then((response) => {
          if (response.status == 200) {
            window.open(response.data, "_blank");
          } else this.$alertMsg(response.data.data.text);
        })
        .catch((err) =>
          err.data == undefined
            ? this.$alertMsg(
                `${this.$t("messages.apiRespondedWithCode")} ${
                  err.response.status
                }`
              )
            : this.$alertMsg(err.data.data.text)
        );
    },
  },
};
